import { Roles } from '@/entities/roles'
import { AcceptDealDialog, useConfirmTopupDialog } from '@/entities/topup'
import {
  DealsInputsBlock,
  MobileBlockDeal,
  TRADER_STATUS_MAP,
  TopupsModel,
  TopupsModelMerchant,
  getColumns,
} from '@/entities/topups'
import { useTopupsQuery } from '@/entities/topups/hooks/useTopupsQuery'
import { USER_ROLE_KEY } from '@/features/auth'
import { FiltersBlock } from '@/shared/components'
import { StateType } from '@/shared/components/FiltersBlock/FiltersBlock'
import { PageTitle } from '@/shared/components/PageTitle/PageTitle'
import { useDebounce } from '@/shared/hooks'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { useState } from 'react'
import { BaseTable, BaseTableSkeleton } from 'syncra-storybook/features'

export const Deals = () => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  const [search, setSearch] = useState('')
  const [searchFilters, setSearchFilters] = useState<StateType | null>(null)
  const [skip, setSkip] = useState(0)
  const [selectedStatus, setSelectedStatus] = useState(1)
  const [selectedTopupId, setSelectedTopupId] = useState<string>('')
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const debouncedSearch = useDebounce(search, 500)
  const debouncedSkip = useDebounce(skip, 500)
  const effectiveSkip = skip === 0 ? 0 : debouncedSkip

  const status = TRADER_STATUS_MAP[selectedStatus]

  const {
    data: queryTopupsData,
    error: topupsError,
    isLoading: topupsIsLoad,
    queryKey,
  } = useTopupsQuery({
    skip: effectiveSkip,
    id: userRole === Roles.Trader ? debouncedSearch : searchFilters?.transactionId,
    search: userRole === Roles.Trader ? undefined : (searchFilters?.paymentRequisit ?? ''),
    status: userRole === Roles.Trader ? status : (searchFilters?.status ?? undefined),
    startDate: searchFilters?.startDate,
    endDate: searchFilters?.endDate,
    refreshTrigger,
  })

  const { modalVisible, setModalVisible, openDialog, submitDialog } = useConfirmTopupDialog({
    queryKey,
    selectedTopupId,
  })

  const handleConfirmTopup = (id: string) => {
    setSelectedTopupId(id)
    openDialog()
  }

  return (
    <div>
      <PageTitle title="Входящие заявки" className="mb-8" />

      {userRole === Roles.Trader ? (
        <DealsInputsBlock
          setQuery={setSearch}
          selectedIndex={selectedStatus}
          selectFilterBtn={(index) => {
            setSelectedStatus(index)
            setSkip(0)
          }}
        />
      ) : (
        <FiltersBlock
          onSubmit={(filters) => {
            setSearchFilters(filters)
            setSkip(0)
            setRefreshTrigger((prev) => prev + 1)
          }}
          // onReset={() => {
          //   setSearchFilters(null)
          //   setSkip(0)
          // }}
        />
      )}

      {topupsError ? (
        <p>Ошибка загрузки данных.</p>
      ) : topupsIsLoad ? (
        <BaseTableSkeleton />
      ) : !queryTopupsData?.items || queryTopupsData.items.length === 0 ? (
        <p>Входящих заявок нет.</p>
      ) : (
        <BaseTable
          data={queryTopupsData.items}
          columns={getColumns({ onConfirm: handleConfirmTopup, userRole, selectedStatus })}
          onPageChange={(newSkip) => setSkip(newSkip)}
          totalItems={queryTopupsData.count ?? 0}
          skip={skip}
          cardClasses="border-0"
          mobileCards={queryTopupsData?.items?.map((deal) => (
            <MobileBlockDeal key={deal.id} deal={deal as TopupsModel & TopupsModelMerchant} userRole={userRole} />
          ))}
        />
      )}
      <AcceptDealDialog
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        onSubmit={submitDialog}
      />
    </div>
  )
}
